const need = document.head.querySelector('meta[name="cookie-modal"]').content;

// the Google consent default (everything denied) is set in the page head (common/head.blade.php), before this
// bundle and the admin's Google tag script
if(need != 1){
    window.addEventListener('load', () => {
        setTimeout(() => {
            setUserId();
        },100);
    });
}

function setUserId() {
    let loginToken = Cookies.getItem("login_token");
    if(loginToken === undefined || loginToken === null){
        return;
    }
    ProfileSession.userInfo(loginToken).then(function (userInfo) {
        if(userInfo) {
            AppEvents.callEvent("SET_USER_ID", {
                user_id: userInfo.id,
                email: userInfo.crmItemContacts[0]?.email,
                phone: userInfo.crmItemContacts[0]?.phone,
                city: userInfo.invoice_city,
                post_code: userInfo.invoice_post_code,
                last_name: userInfo.last_name,
                first_name: userInfo.first_name,
            });
        }
    });
}

function setGtagCookie(cookie) {
    if(typeof gtag !== "undefined") {
        if (cookie.categories.includes('analytics')) {
            gtag('consent', 'update', {
                'analytics_storage': 'granted'
            });
            window.addEventListener('load', () => {
                setTimeout(() => {
                    setUserId();
                },100);
            });
        }else{
            gtag('consent', 'update', {
                'analytics_storage': 'denied'
            });
        }
        if (cookie.categories.includes('ad')) {
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'personalization_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
            });
        }else{
            gtag('consent', 'update', {
                'ad_storage': 'denied',
                'personalization_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
            });
        }
    }
}

function CookiesRun()
{
    const cc = window.initCookieConsent();

    cc.run({
        autorun: need == 1,
        mode: (need == 1) ? 'opt-in' : 'opt-out',
        page_scripts: true,
        delay: 850,
        auto_language: "document",
        autoclear_cookies: true,
        force_consent: true,
        cookie_necessary_only_expiration: 1,

        gui_options: {
            consent_modal: {
                layout: 'box',               // box/cloud/bar
                position: 'middle center',     // bottom/middle/top + left/right/center
                transition: 'zoom',           // zoom/slide
            },
            settings_modal: {
                layout: 'box',                 // box/bar
                transition: 'zoom'            // zoom/slide
            }
        },


        onAccept: function (cookie) {
            setGtagCookie(cookie);
        },

        onChange: function (cookie, changedCategories) {
            setGtagCookie(cookie);
        },

        languages: {
            en: {
                consent_modal: {
                    title: lang.cookie.consent_modal.title,
                    description: lang.cookie.consent_modal.description,
                    primary_btn: {
                        text: lang.cookie.consent_modal.primary_btn,
                        role: 'accept_all'
                    },
                    secondary_btn: {
                        text: lang.cookie.consent_modal.secondary_btn,
                        role: 'settings'
                    }
                },
                settings_modal: {
                    title: lang.cookie.settings_modal.title,
                    save_settings_btn: lang.cookie.settings_modal.save_settings_btn,
                    accept_all_btn: lang.cookie.settings_modal.accept_all_btn,
                    reject_all_btn: lang.cookie.settings_modal.reject_all_btn,
                    blocks: [
                        {
                            title: lang.cookie.settings_modal.blocks.first.title,
                            description: lang.cookie.settings_modal.blocks.first.description,
                        }, {
                            title: lang.cookie.settings_modal.blocks.necessary.title,
                            description: lang.cookie.settings_modal.blocks.necessary.description,
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            }
                        }, {
                            title: lang.cookie.settings_modal.blocks.analytics.title,
                            description: lang.cookie.settings_modal.blocks.analytics.description,
                            toggle: {
                                value: 'analytics',
                                enabled: false,
                                readonly: false,
                                reload: 'on_disable'
                            },
                        },
                        {
                            title: lang.cookie.settings_modal.blocks.ad.title,
                            description: lang.cookie.settings_modal.blocks.ad.description,
                            toggle: {
                                value: 'ad',
                                enabled: false,
                                readonly: false,
                                reload: 'on_disable'
                            },
                        },
                        {
                            title: lang.cookie.settings_modal.blocks.more.title,
                            description: lang.cookie.settings_modal.blocks.more.description,
                        }
                    ]
                }
            }
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => CookiesRun(),0);
});

if (document.readyState !== 'loading') {
    setTimeout(() => CookiesRun(),0);
}
